import { render } from "./RepairInfoListView.vue?vue&type=template&id=3b1d139c&scoped=true"
import script from "./RepairInfoListView.vue?vue&type=script&lang=js"
export * from "./RepairInfoListView.vue?vue&type=script&lang=js"

import "./RepairInfoListView.vue?vue&type=style&index=0&id=3b1d139c&scoped=true&lang=css"

import exportComponent from "E:\\源码\\baoxiu\\baoxiu\\VUE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1d139c"]])

export default __exports__